import { SortOrderTypeFavoriteCorps } from "enums";
import { ItemSearchOptions } from "models";
import React, { useEffect } from "react";

type PROPS = {
  options: ItemSearchOptions;
  onChange: () => void;
};

const FavoriteCorpSearchSortSelect: React.FC<PROPS> = (props) => {
  const [sortOrder, setSortOrder] = React.useState<string>("");

  useEffect(() => {
    const tmp = props.options.sort_order ?? "";
    setSortOrder(tmp);
  }, [props.options.sort_order]);

  return (
    <select
      className="border border-gray-600 rounded py-2 cursor-pointer"
      value={sortOrder}
      onChange={(e) => {
        const value = e.target.value;
        props.options.sort_order = value;
        setSortOrder(value);

        props.onChange();
      }}
    >
      <option value={SortOrderTypeFavoriteCorps.ADD_DATE_NEW}>
        追加日が新しい順
      </option>
      <option value={SortOrderTypeFavoriteCorps.ADD_DATE_OLD}>
        追加日が古い順
      </option>
      <option value={SortOrderTypeFavoriteCorps.CORP_NAME_ASC}>
        会社名昇順
      </option>
      <option value={SortOrderTypeFavoriteCorps.CORP_NAME_DESC}>
        会社名降順
      </option>
      <option value={SortOrderTypeFavoriteCorps.CAPITAL_MANY}>
        資本金が多い順
      </option>
    </select>
  );
};

export default FavoriteCorpSearchSortSelect;
